import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import RightBar from "./components/RightBar";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Work from "./components/Work";
import Contact from "./components/Contact";
import Skills from "./components/Skills";
import { Loader } from "./components/Loader";
import NeonTrail from "./components/NeonTrail";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <>
      <NeonTrail />
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* Fixed sidebars */}
          <Sidebar />
          <RightBar />

          {/* Main content */}
          <Navbar />
          <main>
            <Hero />
            <About />
            <Skills />
            <Experience />
            <Work />
            <Contact />
          </main>
        </>
      )}
    </>
  );
}

export default App;
